import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/date-icon.svg'
import _imports_1 from '@/assets/images/claim/rect.png'
import _imports_2 from '@/assets/images/vl/download.svg'


const _withScopeId = n => (_pushScopeId("data-v-61f105a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "searchCon" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "devider" }, null, -1))
const _hoisted_3 = { class: "leftCon" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "VIN", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Plate No.", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Customer", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Vehicle Type", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Engine No码", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Use Character", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text" }, "Registration Date", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text" }, "Issue Date", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_14 = { class: "rightCon" }
const _hoisted_15 = { class: "licenseImg" }
const _hoisted_16 = { class: "licenseTop" }
const _hoisted_17 = { class: "licenseBottom clearfix" }
const _hoisted_18 = { class: "licenseName" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 下载图片 ")
const _hoisted_20 = { class: "otherCon" }
const _hoisted_21 = {
  class: "tabCon",
  ref: "tabCon"
}
const _hoisted_22 = { class: "tabInfoCon clearfix" }
const _hoisted_23 = { class: "flexCon firstFlexCon" }
const _hoisted_24 = { class: "flexDetCon firstFlexDetCon" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flexTit" }, "有效性核查", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flexDet flexSecTit" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flexDetList" }, "1-零售"),
  /*#__PURE__*/_createElementVNode("div", { class: "flexDetList" }, "2-车牌号"),
  /*#__PURE__*/_createElementVNode("div", { class: "flexDetList" }, "3-行驶证")
], -1))
const _hoisted_27 = { class: "flexDet flexThirdCon thirdPart clearfix" }
const _hoisted_28 = { class: "flexDetList" }
const _hoisted_29 = { class: "flexDetList" }
const _hoisted_30 = { class: "flexDetList" }
const _hoisted_31 = { class: "flexDetCon secondFlexDetCon" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flexTit" }, "时效性核查", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flexDet flexSecTit" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flexDetList" }, "4-上牌"),
  /*#__PURE__*/_createElementVNode("div", { class: "flexDetList" }, "5-提交")
], -1))
const _hoisted_34 = { class: "flexDet flexThirdCon halfPart clearfix" }
const _hoisted_35 = { class: "flexDetList" }
const _hoisted_36 = { class: "flexDetList" }
const _hoisted_37 = { class: "flexDetCon thirdFlexDetCon" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flexTit" }, "一致性核查", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flexDet flexSecTit" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flexDetList" }, "6-VIN"),
  /*#__PURE__*/_createElementVNode("div", { class: "flexDetList" }, "7-车牌号"),
  /*#__PURE__*/_createElementVNode("div", { class: "flexDetList" }, "8-上牌日期")
], -1))
const _hoisted_40 = { class: "flexDet flexThirdCon thirdPart clearfix" }
const _hoisted_41 = { class: "flexDetList" }
const _hoisted_42 = { class: "flexDetList" }
const _hoisted_43 = { class: "flexDetList" }
const _hoisted_44 = { class: "flexCon secondFlexCon" }
const _hoisted_45 = { class: "flexDetCon" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flexDet flexTit" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flexDetList" }, "自动核查"),
  /*#__PURE__*/_createElementVNode("div", { class: "flexDetList" }, "经销商修改")
], -1))
const _hoisted_47 = { class: "flexDet flexThirdCon halfPart clearfix" }
const _hoisted_48 = { class: "flexDetList" }
const _hoisted_49 = { class: "flexDetList" }
const _hoisted_50 = { class: "flexCon thirdFlexCon" }
const _hoisted_51 = { class: "flexDetCon" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flexDet flexTit" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flexDetList" }, "有效提交"),
  /*#__PURE__*/_createElementVNode("div", { class: "flexDetList" }, "反馈信息")
], -1))
const _hoisted_53 = { class: "flexDet flexThirdCon halfPart clearfix" }
const _hoisted_54 = { class: "flexDetList" }
const _hoisted_55 = { class: "flexDetList" }
const _hoisted_56 = {
  key: 0,
  class: "warning"
}
const _hoisted_57 = { class: "table-box" }
const _hoisted_58 = {
  key: 0,
  class: "addCon"
}
const _hoisted_59 = {
  key: 1,
  class: "addCon"
}
const _hoisted_60 = /*#__PURE__*/_createTextVNode("Delete")
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Add ")
const _hoisted_62 = { class: "appealCon clearfix" }
const _hoisted_63 = { class: "halfPart" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "appealTitCon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "rect"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "appealTit" }, "申诉理由描述")
], -1))
const _hoisted_65 = { class: "appealContent" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "appealCommentTit" }, "描述", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "appealTitCon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "rect"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "appealTit" }, "申诉文件")
], -1))
const _hoisted_68 = {
  key: 0,
  class: "appealContent"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "download"
}, null, -1))
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" Download ")
const _hoisted_71 = { class: "appealListCon clearfix" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = { class: "fl" }
const _hoisted_74 = { class: "appealListTit" }
const _hoisted_75 = { class: "fr" }
const _hoisted_76 = { class: "appealListSize" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "download"
}, null, -1))
const _hoisted_78 = { class: "halfPart" }
const _hoisted_79 = { class: "licenseView" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "licenseShow-title" }, "申诉行驶证文件", -1))
const _hoisted_81 = { class: "licenseShow" }
const _hoisted_82 = { class: "licenseShowVis" }
const _hoisted_83 = { class: "buttonDownload" }
const _hoisted_84 = { class: "pictureTitle" }
const _hoisted_85 = { class: "uploadBtn" }
const _hoisted_86 = /*#__PURE__*/_createTextVNode("下载图片 ")
const _hoisted_87 = {
  key: 0,
  class: "btnCon"
}
const _hoisted_88 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_89 = /*#__PURE__*/_createTextVNode("Ok")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_pdf_preview = _resolveComponent("pdf-preview")!
  const _component_image_preview = _resolveComponent("image-preview")!
  const _component_DownloadOutlined = _resolveComponent("DownloadOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_PlusCircleOutlined = _resolveComponent("PlusCircleOutlined")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_LinkOutlined = _resolveComponent("LinkOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_UploadOutlined = _resolveComponent("UploadOutlined")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_notice_modal = _resolveComponent("notice-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_space, {
          direction: "vertical",
          class: "spaceMargin"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createVNode(_component_a_input, {
              value: _ctx.basicParams.vinNo,
              placeholder: "请输入",
              maxlength: 17,
              disabled: "",
              style: {"width":"210px"}
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_space, {
          direction: "vertical",
          class: "spaceMargin"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createVNode(_component_a_input, {
              value: _ctx.basicParams.licenseNumber,
              placeholder: "请输入",
              disabled: "",
              style: {"width":"210px"}
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_space, {
          direction: "vertical",
          class: "spaceMargin"
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createVNode(_component_a_input, {
              value: _ctx.basicParams.customerName,
              placeholder: "请输入",
              disabled: "",
              style: {"width":"210px"}
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_space, {
          direction: "vertical",
          class: "spaceMargin"
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _createVNode(_component_a_input, {
              value: _ctx.basicParams.vehicleType,
              style: {"width":"210px"},
              ref: "input",
              disabled: "",
              allowClear: ""
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_space, {
          direction: "vertical",
          class: "spaceMargin"
        }, {
          default: _withCtx(() => [
            _hoisted_8,
            _createVNode(_component_a_input, {
              value: _ctx.basicParams.engineNo,
              placeholder: "请输入",
              disabled: "",
              style: {"width":"210px"}
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_space, {
          direction: "vertical",
          class: "spaceMargin"
        }, {
          default: _withCtx(() => [
            _hoisted_9,
            _createVNode(_component_a_input, {
              value: _ctx.basicParams.useNatue,
              style: {"width":"210px"},
              ref: "select",
              disabled: "",
              allowClear: ""
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_space, {
          direction: "vertical",
          class: "spaceMargin"
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _createVNode(_component_a_date_picker, {
              style: {"width":"210px"},
              valueFormat: "YYYY/MM/DD",
              format: "YYYY/MM/DD",
              value: _ctx.basicParams.regDate,
              disabled: ""
            }, {
              suffixIcon: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_space, {
          direction: "vertical",
          class: "spaceMargin"
        }, {
          default: _withCtx(() => [
            _hoisted_12,
            _createVNode(_component_a_date_picker, {
              style: {"width":"210px"},
              valueFormat: "YYYY/MM/DD",
              format: "YYYY/MM/DD",
              value: _ctx.basicParams.issueDate,
              disabled: ""
            }, {
              suffixIcon: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            (_ctx.picParams.docType === 'PDF')
              ? (_openBlock(), _createBlock(_component_pdf_preview, {
                  key: 0,
                  "base64-data": _ctx.picParams.base64
                }, null, 8, ["base64-data"]))
              : (_openBlock(), _createBlock(_component_image_preview, {
                  key: 1,
                  src: _ctx.picParams.downloadUrl
                }, null, 8, ["src"]))
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.picParams.docName), 1),
            _createVNode(_component_a_button, {
              class: "licenseBtn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadImg('RE_' + _ctx.basicParams.vinNo + '.jpg', _ctx.picParams.downloadUrl)))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_DownloadOutlined)
              ]),
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", {
          class: _normalizeClass(["whiteBG", {
          secondBG: _ctx.activeKey == '2',
          thirdBG: _ctx.activeKey == '3'
        }])
        }, null, 2),
        _createVNode(_component_a_tabs, {
          type: "card",
          activeKey: _ctx.activeKey,
          "onUpdate:activeKey": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.activeKey) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tab_pane, {
              key: "1",
              tab: "Checking Info"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _hoisted_26,
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_a_select, {
                            value: _ctx.checkingParams.retailValidateCheck,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checkingParams.retailValidateCheck) = $event)),
                            style: {"width":"70%","background-color":"#dddcdc"},
                            ref: "select",
                            allowClear: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chooseArray, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, { key: item }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_a_select, {
                            value: _ctx.checkingParams.vinValidateCheck,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checkingParams.vinValidateCheck) = $event)),
                            style: {"width":"70%","background-color":"#dddcdc"},
                            ref: "select",
                            allowClear: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chooseArray, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, { key: item }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_a_select, {
                            value: _ctx.checkingParams.licenseValidateCheck,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checkingParams.licenseValidateCheck) = $event)),
                            style: {"width":"70%"},
                            ref: "select",
                            allowClear: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chooseArray, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, { key: item }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_a_select, {
                            value: _ctx.checkingParams.regPrescriptionCheck,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.checkingParams.regPrescriptionCheck) = $event)),
                            style: {"width":"95%","background-color":"#dddcdc"},
                            ref: "select",
                            allowClear: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chooseArray, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, { key: item }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(_component_a_select, {
                            value: _ctx.checkingParams.submitPrescriptionCheck,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.checkingParams.submitPrescriptionCheck) = $event)),
                            style: {"width":"95%","background-color":"#dddcdc"},
                            ref: "select",
                            allowClear: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chooseArray, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, { key: item }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _hoisted_39,
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createVNode(_component_a_select, {
                            value: _ctx.checkingParams.vinUniformityCheck,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.checkingParams.vinUniformityCheck) = $event)),
                            style: {"width":"70%"},
                            ref: "select",
                            allowClear: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chooseArray, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, { key: item }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _createVNode(_component_a_select, {
                            value: _ctx.checkingParams.licenseUniformityCheck,
                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.checkingParams.licenseUniformityCheck) = $event)),
                            style: {"width":"70%"},
                            ref: "select",
                            allowClear: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chooseArray, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, { key: item }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createVNode(_component_a_select, {
                            value: _ctx.checkingParams.regDateUniformityCheck,
                            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.checkingParams.regDateUniformityCheck) = $event)),
                            style: {"width":"70%"},
                            ref: "select",
                            allowClear: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chooseArray, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, { key: item }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _hoisted_46,
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _createVNode(_component_a_select, {
                            value: _ctx.checkingParams.checkResult,
                            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.checkingParams.checkResult) = $event)),
                            style: {"width":"95%"},
                            ref: "select",
                            disabled: true,
                            allowClear: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkResultArray, (item, index) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  value: item.value,
                                  key: index
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.text), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _createVNode(_component_a_select, {
                            value: _ctx.checkingParams.retailModifi,
                            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.checkingParams.retailModifi) = $event)),
                            style: {"width":"95%"},
                            ref: "select",
                            disabled: true,
                            allowClear: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chooseArray, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, { key: item }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _hoisted_52,
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _createVNode(_component_a_select, {
                            value: _ctx.checkingParams.effectiveSubmitted,
                            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.checkingParams.effectiveSubmitted) = $event)),
                            style: {"width":"95%"},
                            ref: "select",
                            onChange: _ctx.effectiveSubmittedChange
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chooseArray, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  value: item,
                                  key: item
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value", "onChange"])
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _createVNode(_component_a_select, {
                            class: "y-select",
                            mode: "multiple",
                            value: _ctx.checkingParams.feedbackInfo,
                            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.checkingParams.feedbackInfo) = $event)),
                            dropdownMatchSelectWidth: false,
                            dropdownStyle: {
                        width: '420px',
                        left: 'auto',
                        right: '50px'
                      },
                            style: {"width":"95%"},
                            ref: "select"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkArray, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, { key: item }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"]),
                          (_ctx.isFeedBackInfoEmpty)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, "不允许为空"))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_tab_pane, {
              key: "2",
              tab: "Comment"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["tableCon", { noDataTable: _ctx.commentParams.length == 0 }])
                }, [
                  _createElementVNode("div", _hoisted_57, [
                    _createVNode(_component_a_table, {
                      columns: _ctx.columns,
                      pagination: false,
                      dataSource: _ctx.commentParams,
                      rowKey: "id",
                      scroll: { y: 60 },
                      rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null)
                    }, {
                      comment: _withCtx(({ record }) => [
                        (record.comment)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(record.comment), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                              _createVNode(_component_a_input, {
                                value: _ctx.addCommentInfo,
                                "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.addCommentInfo) = $event)),
                                placeholder: "请输入",
                                style: {"width":"90%"},
                                onBlur: _ctx.addCommentList
                              }, null, 8, ["value", "onBlur"])
                            ]))
                      ]),
                      operation: _withCtx(({ record }) => [
                        _createVNode(_component_a_button, {
                          type: "link",
                          onClick: ($event: any) => (_ctx.handleDelete(record))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_60
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    }, 8, ["columns", "dataSource", "rowClassName"])
                  ]),
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: _ctx.handleAdd,
                    disabled: _ctx.addDisabled
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_PlusCircleOutlined)
                    ]),
                    default: _withCtx(() => [
                      _hoisted_61
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"])
                ], 2)
              ]),
              _: 1
            }),
            _createVNode(_component_a_tab_pane, {
              key: "3",
              tab: "Appeal Info",
              class: "lightBG"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("div", _hoisted_63, [
                    _hoisted_64,
                    _createElementVNode("div", _hoisted_65, [
                      _hoisted_66,
                      _createVNode(_component_a_textarea, {
                        value: _ctx.appealParams.appealComment,
                        placeholder: "请输入",
                        disabled: ""
                      }, null, 8, ["value"])
                    ]),
                    _hoisted_67,
                    (_ctx.appealParams.appealFileList && _ctx.appealParams.appealFileList.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                          _createVNode(_component_a_button, {
                            class: "button downloadBtn",
                            onClick: _ctx.exportFile
                          }, {
                            default: _withCtx(() => [
                              _hoisted_69,
                              _hoisted_70
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createElementVNode("div", _hoisted_71, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appealParams.appealFileList, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "appealList clearfix",
                                key: item.id,
                                onClick: ($event: any) => (_ctx.singleExportFile(item))
                              }, [
                                _createElementVNode("div", _hoisted_73, [
                                  _createVNode(_component_LinkOutlined),
                                  _createVNode(_component_a_tooltip, null, {
                                    title: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.fileName), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_74, _toDisplayString(item.fileName), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _createElementVNode("div", _hoisted_75, [
                                  _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.computeSize(item.fileSize)), 1),
                                  _hoisted_77
                                ])
                              ], 8, _hoisted_72))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, [
                      _hoisted_80,
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("div", _hoisted_82, [
                          (_ctx.appealDownloadDetail?.downloadUrl)
                            ? (_openBlock(), _createBlock(_component_a_image, {
                                key: 0,
                                src: _ctx.appealDownloadDetail.downloadUrl
                              }, null, 8, ["src"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("div", _hoisted_84, _toDisplayString(_ctx.appealDownloadDetail?.docName), 1),
                          _createElementVNode("div", _hoisted_85, [
                            _createVNode(_component_a_button, {
                              class: "button mr30",
                              disabled: !_ctx.appealDownloadDetail?.downloadUrl,
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.downloadImg(`RE_${_ctx.basicParams.vinNo}.jpg`, _ctx.appealDownloadDetail.downloadUrl)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_UploadOutlined),
                                _hoisted_86
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["activeKey"])
      ], 512),
      (_ctx.activeKey == '1')
        ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
            _createVNode(_component_a_button, {
              class: "button",
              onClick: _ctx.cancel
            }, {
              default: _withCtx(() => [
                _hoisted_88
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_a_button, {
              type: "primary",
              class: "button",
              onClick: _ctx.saveCheckInfo
            }, {
              default: _withCtx(() => [
                _hoisted_89
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.modalVisible)
      ? (_openBlock(), _createBlock(_component_notice_modal, {
          key: 0,
          modalVisible: _ctx.modalVisible,
          modalData: _ctx.modalData,
          onCloseModalVisible: _ctx.closeModal
        }, null, 8, ["modalVisible", "modalData", "onCloseModalVisible"]))
      : _createCommentVNode("", true)
  ], 64))
}